var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _rect2, _path27, _rect3, _path28, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNoTasks = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 149,
    viewBox: "0 0 190 149",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.95 13L101.23 11.3043C99.6722 6.5314 106.607 4.81063 105.05 0L109.77 1.69566C111.328 6.50628 104.393 8.22706 105.95 13Z",
    fill: "#83A9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8583 46.4481L10.5329 50.5298C5.96103 51.2656 5.56052 44.6618 0.968005 45.3768L3.28072 41.2993C7.87324 40.5842 8.27376 47.188 12.8583 46.4481Z",
    fill: "#84C8B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.985 66.4817L173 61.2481C174.721 54.9639 183.608 58.2842 185.329 52L189.314 57.3275C187.574 63.5179 178.706 60.1976 176.985 66.4817Z",
    fill: "#84C8B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.573 15.6078L39.8613 18.3965C35.4798 17.1877 37.7916 10.9785 33.4273 9.7623L37.1464 6.99083C41.5107 8.20699 39.1989 14.4163 43.573 15.6078Z",
    fill: "#F17105"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.868 31.8255C120.501 28.0861 117.217 25.3228 113.47 25.601L36.25 31.333C32.2165 31.6324 29.2987 35.3129 29.9274 39.3084L40.3129 105.312L127.104 95.4017L120.868 31.8255Z",
    fill: "#9D9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138 67L149.5 59",
    stroke: "#FF725E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140 89.9044L154.879 94.4994",
    stroke: "#FF725E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.999 78.2906L157.26 75.1912",
    stroke: "#FF725E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.426 34.2083C116.293 32.9725 115.205 32.0644 113.965 32.1549L40.1928 37.541C37.505 37.7373 35.5572 40.1862 35.9707 42.8492L45.5493 104.534L122.988 95.1785L116.426 34.2083Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.362 32.0256C116.267 30.743 115.14 29.7867 113.859 29.9003L37.5993 36.6622C36.2871 36.7786 35.3388 37.9685 35.5182 39.2735L36.3014 44.9725L116.746 37.1617L116.362 32.0256Z",
    fill: "#D2D2D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.537 95.4859L40.3139 105.312L73.1982 136.154C73.7115 136.636 74.4165 136.856 75.1128 136.754L160.354 124.169C162.414 123.865 163.048 121.201 161.345 120.002L126.537 95.4859Z",
    fill: "#9D9D9D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.895 100.629L52.6688 109.097",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.873 105.109L59.1459 114.573",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.842 111.09L66.6165 120.056",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.895 100.629L138.842 111.089",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.424 101.625L130.873 112.085",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.959 102.621L120.91 113.579",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4907 103.617L111.943 114.077",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5258 104.613L103.975 115.572",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5591 105.609L94.0117 117.066",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0999 107.102L85.0469 118.06",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6351 108.098L75.582 119.056",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1721 109.098L66.6172 120.056",
    stroke: "#838282",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9429 139.28L72.6215 135.377L40.229 104.741L40.573 107.072C40.8392 108.874 41.7074 110.534 43.0365 111.781L73.0023 139.885C73.4399 140.296 74.1352 139.848 73.9429 139.28Z",
    fill: "#858585"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.24 124.38L162.486 122.691L72.7055 135.946L73.2076 139.347C73.3936 140.607 74.5659 141.478 75.826 141.292L157.377 129.252C159.896 128.88 161.872 126.9 162.24 124.38Z",
    fill: "#888888"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M121.074 116.747C120.577 116.36 119.943 116.193 119.319 116.285L93.6374 120.076C92.69 120.216 92.3161 121.383 93.0057 122.047L102.811 131.496L134.074 126.88L121.074 116.747Z",
    fill: "#777777"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86.9397,
    height: 11.0802,
    rx: 1,
    transform: "matrix(-0.995534 0.0943986 0.0943986 0.995534 143.551 39)",
    fill: "#79A2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.225284,
    y: 0.272483,
    width: 9.91173,
    height: 10.5802,
    rx: 0.75,
    transform: "matrix(-0.995534 0.0943986 0.0943986 0.995534 53.89 48.0225)",
    fill: "white",
    stroke: "#3C9275",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.127 55.0742L50.127 56.5781L52.625 50.5742",
    stroke: "#3C9275",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.225284,
    y: 0.272483,
    width: 9.91173,
    height: 10.5802,
    rx: 0.75,
    transform: "matrix(-0.995534 0.0943986 0.0943986 0.995534 26.4583 67.5576)",
    fill: "white",
    stroke: "#3C9275",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6953 74.6094L22.6953 76.1133L25.1934 70.1094",
    stroke: "#3C9275",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 74.7473,
    height: 10.3391,
    rx: 2,
    transform: "matrix(-0.994526 0.104492 0.104492 0.994526 103.805 58.8359)",
    fill: "#F2AE43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.25402,
    y: 0.318896,
    width: 56.4349,
    height: 9.76248,
    rx: 0.711712,
    transform: "matrix(-0.99365 0.112519 0.112519 0.99365 116.216 75.7962)",
    stroke: "#777777",
    strokeWidth: 0.576577,
    strokeDasharray: "1.15 1.15"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoTasks, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/noTasks.03329385.svg";
export { ForwardRef as ReactComponent };